<template>
  <Modal class="full-screen-preview">
    <template v-slot:header><span></span></template>
    <template v-slot:body>
      <Gallery :value="images" class="vh-100" :background="background" :index="index" :thumbnail="thumbnail" :config="config?.data?.config || {}">
        <template v-slot:before-wrapper>
          <div class="icon-close" @click="closeModal()">
            <span>×</span>
          </div>
        </template>
      </Gallery>
    </template>
    <template v-slot:footer><span></span></template>
  </Modal>
</template>

<script>
import Gallery from '@/components/Gallery.vue'
import Modal from '@/components/BaseModal.vue'
export default {
  components: {
    Gallery,
    Modal
  },
  computed: {
    images() {
      return this.config?.data.files
    },
    background() {
      return this.config?.data.background || false
    },
    index() {
      return this.config?.data.index || 0
    },
    thumbnail() {
      return this.config?.data.thumbnail || false
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
      if (this.$route?.path == '/preview') window.close()
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.modal.full-screen-preview {
  .modal-header,
  .modal-footer {
    display: none;
  }
  .modal-dialog {
    width: 100% !important;
    height: 100% !important;
    max-width: 100% !important;
    max-height: 100% !important;
    padding: 0;
    margin: 0;
    border: 0;
  }
  .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
    .modal-body {
      padding: 0px !important;
    }
  }
  .icon-close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    opacity: 0.5;
    z-index: 999;
    &:hover {
      opacity: 0.75;
    }
    > span {
      vertical-align: middle;
      display: contents;
      font-size: 1.5rem;
      font-weight: 700;
      line-height: 1;
      color: #000;
      text-shadow: 0 1px 0 #fff;
    }
  }
}
</style>
